import isNil from 'lodash/isNil';

/**
 * Method for parse the faceted filters
 * @param {Array} faceted - the filters from the payload
 * @returns {Object} - The adapted value
 */
const availableFiltersAdapter = (faceted = []) =>
    faceted && faceted.map(({ id, type, description, ...rest }) => {
        if (type === 'range') {
            const { range } = rest;

            return { id, type, description, range };
        }
        const { values: valuesOrg } = rest;
        const values = valuesOrg && valuesOrg.filter && valuesOrg.filter(({ id }) => id !== '-1');

        return { id, type, description, values };
    });

/**
 * Method for parse the applied filters values
 * @param {Array} filterValues - The appliedFilters value
 * @param {String|Number} [filterValues.id] - The Id of the filter
 * @param {String|Number} [filterValues.key] - The key of the filter
 * @param {String} [filterValues.name] - The description of the filter value
 * @param {String} [filterValues.description] - The description of the filter value
 * @returns {Object} - The adapted value
 */
const appliedValuesParser = (filterValues = []) => ({
    values: filterValues.map(filter => {
        let value;

        if (!isNil(filter.max_value)) {
            value = { value: filter.max_value };
        }
        if (!isNil(filter.min_value)) {
            value = { value: filter.min_value };
        }
        return {
            key: filter.key || filter.id,
            id: filter.key || filter.id,
            description: filter.description || filter.name,
            ...value
        };
    })
});

/**
 * Method for parse a single applied filter
 * @param {String|Number} key - The Id of the filter
 * @param {String|Number} description - The key of the filter
 * @returns {Object} - The adapted value
 */
const appliedSingleValueParser = (key, description) =>
    appliedValuesParser([{ key, description }]);

/**
 * Method for parse the applied filters from the API
 * @param {Array} faceted - The appliedFilters value
 * @param {String|Number} faceted.id - The Id of the filter
 * @param {String} [filterValues.name] - The description of the filter value
 * @param {String} [filterValues.description] - The description of the filter value
 * @param {Array} [filterValues.values] - The values of the applied filter
 * @param {Array} [filterValues.applied_value] - The value of a single applied filter
 * @param {Array} [filterValues.value] - The description of a single applied filter
 * @returns {Array} - The adapted value
 */
const filtersAppliedAdapter = (faceted = []) =>
    faceted.map(facetFilter => {
        const appliedValues = facetFilter.values
            ? appliedValuesParser(facetFilter.values)
            : appliedSingleValueParser(facetFilter.applied_value, facetFilter.value);

        return {
            id: facetFilter.id,
            description: facetFilter.name || facetFilter.description,
            ...appliedValues
        };
    });

export { filtersAppliedAdapter, availableFiltersAdapter };
